import { Modal as AntModal } from "antd"
import { ModalProvider } from "components/providers/Modal.provider"
import { ReactNode } from "react"
import type { ModalProps } from "antd"

type Props = {
	className?: string
	title?: string
	children: ReactNode
	width?: number | string
	centered?: boolean
	isModalOpen: boolean
	setModalClose: () => void
	closable?: boolean
	maskClosable?: boolean
	getContainer?: string | HTMLElement | (() => HTMLElement) | false
	styles?: ModalProps["styles"]
}

export const Modal = ({
	className = "",
	title,
	children,
	width = 460,
	centered = true,
	isModalOpen,
	setModalClose,
	closable = true,
	maskClosable = true,
	getContainer,
	styles,
}: Props) => {
	return (
		<ModalProvider>
			<AntModal
				className={className}
				title={title}
				width={width}
				open={isModalOpen}
				onCancel={setModalClose}
				footer={false}
				centered={centered}
				closable={closable}
				maskClosable={maskClosable}
				getContainer={getContainer}
				styles={styles}
			>
				<div data-testid="modal">{children}</div>
			</AntModal>
		</ModalProvider>
	)
}
